/**
 * @flow
 * @relayHash bebb54de755ac502fa7e817abaed0792
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type Http4xxErrorsTable_project$ref = any;
export type FilterOperator = "AND" | "OR" | "%future added value";
export type TextFilterOperator = "CONTAINS" | "NOT_CONTAINS" | "REGEXP" | "%future added value";
export type LinkTypeFilter = {
  showExternal?: ?boolean,
  showInternal?: ?boolean,
};
export type TextFilters = {
  operator: FilterOperator,
  values?: ?$ReadOnlyArray<?TextFilter>,
};
export type TextFilter = {
  operator: TextFilterOperator,
  value: string,
};
export type Http4xxErrorsTable_RefetchQueryVariables = {|
  host: string,
  limit?: ?number,
  offset?: ?number,
  codeFilters?: ?$ReadOnlyArray<?number>,
  linkTypeFilter?: ?LinkTypeFilter,
  sourceUrl?: ?TextFilters,
  errorUrl?: ?TextFilters,
|};
export type Http4xxErrorsTable_RefetchQueryResponse = {|
  +project: ?{|
    +$fragmentRefs: Http4xxErrorsTable_project$ref
  |}
|};
export type Http4xxErrorsTable_RefetchQuery = {|
  variables: Http4xxErrorsTable_RefetchQueryVariables,
  response: Http4xxErrorsTable_RefetchQueryResponse,
|};
*/


/*
query Http4xxErrorsTable_RefetchQuery(
  $host: String!
  $limit: Int
  $offset: Int
  $codeFilters: [Int]
  $linkTypeFilter: LinkTypeFilter
  $sourceUrl: TextFilters
  $errorUrl: TextFilters
) {
  project(host: $host) {
    ...Http4xxErrorsTable_project_1SDsod
    id
  }
}

fragment Http4xxErrorsTable_project_1SDsod on Project {
  host
  crawls(offset: 0, limit: 1) {
    edges {
      node {
        countCodesHttp4xxErrors(linkTypeFilter: $linkTypeFilter, errorUrl: $errorUrl, sourceUrl: $sourceUrl) {
          code
          count
        }
        http4xxErrors(offset: $offset, limit: $limit, codeFilters: $codeFilters, linkTypeFilter: $linkTypeFilter, errorUrl: $errorUrl, sourceUrl: $sourceUrl) {
          count
          edges {
            node {
              ...Http4xxErrorsRow_issue
              id
            }
          }
        }
        id
      }
    }
  }
}

fragment Http4xxErrorsRow_issue on Http4xxError {
  id
  type
  severity
  code
  internal
  error_url
  source_url
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "host",
    "type": "String!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "limit",
    "type": "Int",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "offset",
    "type": "Int",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "codeFilters",
    "type": "[Int]",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "linkTypeFilter",
    "type": "LinkTypeFilter",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "sourceUrl",
    "type": "TextFilters",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "errorUrl",
    "type": "TextFilters",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "host",
    "variableName": "host",
    "type": "String!"
  }
],
v2 = {
  "kind": "Variable",
  "name": "errorUrl",
  "variableName": "errorUrl",
  "type": "TextFilters"
},
v3 = {
  "kind": "Variable",
  "name": "linkTypeFilter",
  "variableName": "linkTypeFilter",
  "type": "LinkTypeFilter"
},
v4 = {
  "kind": "Variable",
  "name": "sourceUrl",
  "variableName": "sourceUrl",
  "type": "TextFilters"
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "code",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "count",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "Http4xxErrorsTable_RefetchQuery",
  "id": null,
  "text": "query Http4xxErrorsTable_RefetchQuery(\n  $host: String!\n  $limit: Int\n  $offset: Int\n  $codeFilters: [Int]\n  $linkTypeFilter: LinkTypeFilter\n  $sourceUrl: TextFilters\n  $errorUrl: TextFilters\n) {\n  project(host: $host) {\n    ...Http4xxErrorsTable_project_1SDsod\n    id\n  }\n}\n\nfragment Http4xxErrorsTable_project_1SDsod on Project {\n  host\n  crawls(offset: 0, limit: 1) {\n    edges {\n      node {\n        countCodesHttp4xxErrors(linkTypeFilter: $linkTypeFilter, errorUrl: $errorUrl, sourceUrl: $sourceUrl) {\n          code\n          count\n        }\n        http4xxErrors(offset: $offset, limit: $limit, codeFilters: $codeFilters, linkTypeFilter: $linkTypeFilter, errorUrl: $errorUrl, sourceUrl: $sourceUrl) {\n          count\n          edges {\n            node {\n              ...Http4xxErrorsRow_issue\n              id\n            }\n          }\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment Http4xxErrorsRow_issue on Http4xxError {\n  id\n  type\n  severity\n  code\n  internal\n  error_url\n  source_url\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "Http4xxErrorsTable_RefetchQuery",
    "type": "RootQuery",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "project",
        "storageKey": null,
        "args": v1,
        "concreteType": "Project",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "Http4xxErrorsTable_project",
            "args": [
              {
                "kind": "Variable",
                "name": "codeFilters",
                "variableName": "codeFilters",
                "type": null
              },
              {
                "kind": "Variable",
                "name": "errorUrl",
                "variableName": "errorUrl",
                "type": null
              },
              {
                "kind": "Variable",
                "name": "limit",
                "variableName": "limit",
                "type": null
              },
              {
                "kind": "Variable",
                "name": "linkTypeFilter",
                "variableName": "linkTypeFilter",
                "type": null
              },
              {
                "kind": "Variable",
                "name": "offset",
                "variableName": "offset",
                "type": null
              },
              {
                "kind": "Variable",
                "name": "sourceUrl",
                "variableName": "sourceUrl",
                "type": null
              }
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "Http4xxErrorsTable_RefetchQuery",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "project",
        "storageKey": null,
        "args": v1,
        "concreteType": "Project",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "host",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "crawls",
            "storageKey": "crawls(limit:1,offset:0)",
            "args": [
              {
                "kind": "Literal",
                "name": "limit",
                "value": 1,
                "type": "Int"
              },
              {
                "kind": "Literal",
                "name": "offset",
                "value": 0,
                "type": "Int"
              }
            ],
            "concreteType": "CrawlsConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "CrawlsEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Crawl",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "countCodesHttp4xxErrors",
                        "storageKey": null,
                        "args": [
                          v2,
                          v3,
                          v4
                        ],
                        "concreteType": "CountCode",
                        "plural": true,
                        "selections": [
                          v5,
                          v6
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "http4xxErrors",
                        "storageKey": null,
                        "args": [
                          {
                            "kind": "Variable",
                            "name": "codeFilters",
                            "variableName": "codeFilters",
                            "type": "[Int]"
                          },
                          v2,
                          {
                            "kind": "Variable",
                            "name": "limit",
                            "variableName": "limit",
                            "type": "Int"
                          },
                          v3,
                          {
                            "kind": "Variable",
                            "name": "offset",
                            "variableName": "offset",
                            "type": "Int"
                          },
                          v4
                        ],
                        "concreteType": "Http4xxErrorsConnection",
                        "plural": false,
                        "selections": [
                          v6,
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "edges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Http4xxErrorsEdge",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "node",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "Http4xxError",
                                "plural": false,
                                "selections": [
                                  v7,
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "type",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "severity",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  v5,
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "internal",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "error_url",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "source_url",
                                    "args": null,
                                    "storageKey": null
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      v7
                    ]
                  }
                ]
              }
            ]
          },
          v7
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'e482798363689dd7bc71373a82177f8f';
module.exports = node;
